import React, { useEffect, useState, useContext } from "react";
import "./transactions.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { LanguageContext } from "../../Components/LanguageContext";
import translations from "./translation.json";
import { axiosInstance } from "../../axiosInstance";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

export function Transactions() {
  const [selectedDate, setSelectedDate] = useState("");
  const [recentFirst, setRecentFirst] = useState(false);

  const { language } = useContext(LanguageContext);
  const [activeTab, setActiveTab] = useState("withdrawn");
  const [transaction, setTransaction] = useState([]);
  const [withdraw, setWithDraw] = useState([]);

  const location = useLocation();

  useEffect(() => {
    fetchTransactions();
    fetchWithdrawals();
  }, []);

  const fetchTransactions = async () => {
    try {
      const response = await axiosInstance.get("/agent/online-orders/");
      setTransaction(response.data.results || []);
    } catch (error) {
      console.log("Error while fetching transactions", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "--";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const fetchWithdrawals = async () => {
    try {
      const response = await axiosInstance.get("/agent/withdraw-list/");
      setWithDraw(response.data.data);
    } catch (error) {
      console.log("Error while fetching withdrawals", error);
    }
  };

  const withdrawnColumns = [
    {
      id: "Date",
      label: translations[language].date,
      minWidth: 150,
      align: "center",
    },
    {
      id: "Withdrawnpoints",
      label: translations[language].withdrawn_points,
      minWidth: 100,
      align: "center",
    },
    // {
    //   id: "RemainingPoints",
    //   label: translations[language].remaining_points,
    //   minWidth: 170,
    //   align: "center",
    // },
    {
      id: "payment_status",
      label: translations[language].payment_status,
      minWidth: 170,
      align: "center",
    },
    {
      id: "created_at",
      label: translations[language].created_at,
      minWidth: 170,
      align: "center",
    },
    {
      id: "updated_at",
      label: translations[language].updated_at,
      minWidth: 170,
      align: "center",
    },
  ];

  function handleWithdrawn() {
    const filteredData = selectedDate
      ? withdraw.filter(
          (drawn) => drawn.updated_at.slice(0, 10) === selectedDate,
        )
      : withdraw;
    //  for recentfirst simply reverse the array of data getting from api
    const displayData = recentFirst
      ? [...filteredData].reverse()
      : filteredData;

    const withdrawnRows = displayData.map((drawn) => ({
      Date: drawn.updated_at.slice(0, 10) || "--",
      Withdrawnpoints: drawn.points_to_withdraw || "0",
      // RemainingPoints: drawn.remaining_points || "0",
      PaymentStatus: drawn.payment_status || "Pending",
      CreatedAt: formatDate(drawn.created_at),
      UpdatedAt: formatDate(drawn.updated_at),
    }));
    return (
      <>
        {/* Desktop Table */}
        <div className="withdrawn-table-view">
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer className="tableContainer">
              <Table stickyHeader aria-label="withdrawn table">
                <TableHead>
                  <TableRow>
                    {withdrawnColumns.map((column) => (
                      <TableCell
                        className="trasactiontableHeader"
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {withdrawnRows.length > 0 ? (
                    withdrawnRows.map((row, index) => (
                      <TableRow hover tabIndex={-1} key={index}>
                        {withdrawnColumns.map((column) => {
                          let cellColor = "#716466"; // default color

                          // Color logic for payment status
                          if (column.id === "payment_status") {
                            if (row.PaymentStatus.toLowerCase() === "pending") {
                              cellColor = "#FFA500"; // Orange
                            } else if (
                              row.PaymentStatus.toLowerCase() === "approved"
                            ) {
                              cellColor = "#28a745"; // Green
                            } else if (
                              row.PaymentStatus.toLowerCase() === "rejected"
                            ) {
                              cellColor = "#dc3545"; // Red
                            }
                          }

                          // Color for Withdrawnpoints
                          if (column.id === "Withdrawnpoints") {
                            cellColor = "#AC3047";
                          }

                          // Display correct field based on column id
                          let displayValue = "--";
                          switch (column.id) {
                            case "Date":
                              displayValue = row.Date;
                              break;
                            case "Withdrawnpoints":
                              displayValue = row.Withdrawnpoints;
                              break;
                            case "payment_status":
                              displayValue = row.PaymentStatus;
                              break;
                            case "created_at":
                              displayValue = row.CreatedAt;
                              break;
                            case "updated_at":
                              displayValue = row.UpdatedAt;
                              break;
                            default:
                              displayValue = "--";
                          }

                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className="trasactiontableBody"
                              sx={{ color: cellColor }}
                            >
                              {displayValue}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={withdrawnColumns.length}
                        align="center"
                      >
                        Record not found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>

        {/* Mobile Card View */}
        <div className="withdrawn-card-view">
          {withdrawnRows.length > 0 ? (
            withdrawnRows.map((row, index) => {
              let statusColor = "#FFA500";

              if (row.PaymentStatus.toLowerCase() === "approved") {
                statusColor = "#28a745";
              } else if (row.PaymentStatus.toLowerCase() === "rejected") {
                statusColor = "#dc3545";
              }

              return (
                <div key={index} className="withdrawn-card">
                  <div>
                    <strong>Date:</strong> {row.Date}
                  </div>
                  <div>
                    <strong>Withdrawn Points:</strong> {row.Withdrawnpoints}
                  </div>
                  <div style={{ color: statusColor }}>
                    <strong>Payment Status:</strong> {row.PaymentStatus}
                  </div>
                  <div>
                    <strong>Created At:</strong> {row.CreatedAt}
                  </div>
                  <div>
                    <strong>Updated At:</strong> {row.UpdatedAt}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no-record">Record not found</div>
          )}
        </div>
      </>
    );
  }

  const earnedColumns = [
    { id: "order_id", label: "Order ID", minWidth: 100, align: "center" },
    {
      id: "order_date",
      label: "Order Date",
      minWidth: 200,
      align: "center",
    },
    {
      id: "agent_name",
      label: "Agent Name",
      minWidth: 100,
      align: "center",
    },
    {
      id: "qty",
      label: "Qty",
      minWidth: 150,
      align: "center",
    },
    {
      id: "total_amount",
      label: "Total Amount (₹)",
      minWidth: 170,
      align: "center",
    },
    {
      id: "payment_type",
      label: "Payment type",
      minWidth: 170,
      align: "center",
    },
    {
      id: "reward_points",
      label: "Earned Points",
      minWidth: 170,
      align: "center",
    },
  ];

  function handleEarnedPoints() {
    // const filteredData = selectedDate
    //   ? transaction.filter((t) => t.created_at.slice(0, 10) === selectedDate)
    //   : transaction;

    // const displayData = recentFirst
    //   ? [...filteredData].reverse()
    //   : filteredData;

    // const earnedRows = displayData.map((earned) => ({
    //   id: earned.id || "--",
    //   promo_code_used_by: earned.promo_code_used_by || "--",
    //   points: earned.points || "0",
    //   promo_code: earned.promo_code || "--",
    //   created_at: formatDate(earned.created_at) || "--",
    // }));

    const earnedRows = transaction.map((item) => ({
      order_id: item.order_id || "--",
      order_date: item.order_date || "--",
      agent_name: item.agent_name || "--",
      qty: item.qty || 0,
      total_amount: item.total_amount ?? 0,
      payment_type: item.payment_type || "--",
      reward_points: item.reward_points ?? 0,
    }));

    return (
      <>
        {/* Desktop Table */}
        <div className="withdrawn-table-view">
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer className="tableContainer">
              <Table stickyHeader aria-label="earned table">
                <TableHead>
                  <TableRow>
                    {earnedColumns.map((column) => (
                      <TableCell
                        className="trasactiontableHeader"
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {earnedRows.length > 0 ? (
                    earnedRows.map((row, index) => (
                      <TableRow hover tabIndex={-1} key={index}>
                        {earnedColumns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            className="trasactiontableBody"
                            sx={{
                              color:
                                column.id === "points" ? "#007D1F" : "#716466",
                            }}
                          >
                            {row[column.id]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={earnedColumns.length} align="center">
                        Record not found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>

        {/* Mobile Card View */}
        <div className="withdrawn-card-view">
          {earnedRows.length > 0 ? (
            earnedRows.map((row, index) => (
              <div key={index} className="withdrawn-card">
                <div>
                  <strong>Order ID :</strong> {row.order_id}
                </div>
                <div>
                  <strong>Order Date :</strong> {row.order_date}
                </div>

                <div>
                  <strong>Agent Name :</strong> {row.agent_name}
                </div>
                <div>
                  <strong>Qty :</strong> {row.qty}
                </div>

                <div>
                  <strong>Total Amount (₹) : </strong> {row.total_amount}
                </div>
                <div>
                  <strong>Payment type :</strong> {row.payment_type}
                </div>
                <div>
                  <strong>Earned Points :</strong> {row.reward_points}
                </div>
              </div>
            ))
          ) : (
            <div className="no-record">Record not found</div>
          )}
        </div>
      </>
    );
  }

  return (
    <div className="trasactionContainer">
      <div className="container">
        <div className="trasactionGrid">
          <div className="trasactionMenu">
            <span
              onClick={() => setActiveTab("withdrawn")}
              className={activeTab === "withdrawn" ? "active-tab" : ""}
            >
              {translations[language].withdrawn_points}
            </span>
            <span
              onClick={() => setActiveTab("earned")}
              className={activeTab === "earned" ? "active-tab" : ""}
            >
              {translations[language].earned_points}
            </span>
          </div>
        </div>
        {/* showing content here for selected tabs */}
        <div>
          {activeTab === "withdrawn"
            ? handleWithdrawn()
            : activeTab === "earned"
              ? handleEarnedPoints()
              : null}
        </div>
      </div>
    </div>
  );
}
